export const StateCode = {
  AllStates: '00',
  Johor: '01',
  Kedah: '02',
  Kelantan: '03',
  Melaka: '04',
  NegeriSembilan: '05',
  Pahang: '06',
  PulauPinang: '07',
  Perak: '08',
  Perlis: '09',
  Selangor: '10',
  Terengganu: '11',
  Sabah: '12',
  Sarawak: '13',
  WilayahPersekutuanKualaLumpur: '14',
  WilayahPersekutuanLabuan: '15',
  WilayahPersekutuanPutrajaya: '16',
  NotApplicable: '17',
}

export const states = [
  {
    label: 'Johor',
    code: 'Johor',
    value: StateCode.Johor,
  },
  {
    label: 'Kedah',
    code: 'Kedah',
    value: StateCode.Kedah,
  },
  {
    label: 'Kelantan',
    code: 'Kelantan',
    value: StateCode.Kelantan,
  },
  {
    label: 'Melaka',
    code: 'Melaka',
    value: StateCode.Melaka,
  },
  {
    label: 'Negeri Sembilan',
    code: 'Negeri Sembilan',
    value: StateCode.NegeriSembilan,
  },
  {
    label: 'Pahang',
    code: 'Pahang',
    value: StateCode.Pahang,
  },
  {
    label: 'Pulau Pinang',
    code: 'Pulau Pinang',
    value: StateCode.PulauPinang,
  },
  {
    label: 'Perak',
    code: 'Perak',
    value: StateCode.Perak,
  },
  {
    label: 'Perlis',
    code: 'Perlis',
    value: StateCode.Perlis,
  },
  {
    label: 'Selangor',
    code: 'Selangor',
    value: StateCode.Selangor,
  },
  {
    label: 'Terengganu',
    code: 'Terengganu',
    value: StateCode.Terengganu,
  },
  {
    label: 'Sabah',
    code: 'Sabah',
    value: StateCode.Sabah,
  },
  {
    label: 'Sarawak',
    code: 'Sarawak',
    value: StateCode.Sarawak,
  },
  {
    label: 'Wilayah Persekutuan Kuala Lumpur',
    code: 'Wilayah Persekutuan Kuala Lumpur',
    value: StateCode.WilayahPersekutuanKualaLumpur,
  },
  {
    label: 'Wilayah Persekutuan Labuan',
    code: 'Wilayah Persekutuan Labuan',
    value: StateCode.WilayahPersekutuanLabuan,
  },
  {
    label: 'Wilayah Persekutuan Putrajaya',
    code: 'Wilayah Persekutuan Putrajaya',
    value: StateCode.WilayahPersekutuanPutrajaya,
  },
  {
    label: 'Not Applicable',
    code: 'Not Applicable',
    value: StateCode.NotApplicable,
  },
]
